import { LitElement, html } from 'lit'

/**
 * Componente reutilizável de busca/filtro por texto
 * Filtra em tempo real conforme o usuário digita (busca por trecho)
 * Emite evento 'filter-change' com o texto digitado a cada alteração
 * Utiliza tokens CSS do Design System para cores e estilos visuais
 *
 * Uso:
 *   <search-filter
 *     placeholder="Buscar usuários..."
 *     data-cy="filtro-admin"
 *     @filter-change="${this._onFilterChange}"
 *   ></search-filter>
 */
class SearchFilter extends LitElement {
  static properties = {
    placeholder: { type: String },
    value: { type: String }
  }

  createRenderRoot () {
    return this
  }

  constructor () {
    super()
    this.placeholder = 'Buscar...'
    this.value = ''
  }

  /**
   * Trata input do usuário e emite evento de filtro
   * Dispara a cada caractere digitado para filtragem em tempo real
   * @param {Event} e - Evento de input
   * @private
   */
  _onInput (e) {
    this.value = e.target.value
    this.dispatchEvent(new CustomEvent('filter-change', {
      detail: { value: this.value },
      bubbles: true
    }))
  }

  /**
   * Limpa o campo de busca e emite evento com valor vazio
   * @private
   */
  _clear () {
    this.value = ''
    this.dispatchEvent(new CustomEvent('filter-change', {
      detail: { value: '' },
      bubbles: true
    }))
  }

  render () {
    return html`
      <div class="field mb-4" data-cy="search-filter" style="background-color: var(--bg-surface, #151C30); border-radius: var(--radius-input, 12px);">
        <div class="control has-icons-left ${this.value ? 'has-icons-right' : ''}">
          <input
            class="input is-small"
            type="text"
            .value="${this.value}"
            placeholder="${this.placeholder}"
            data-cy="search-filter-input"
            @input="${this._onInput}"
            style="background-color: var(--bg-surface, #151C30); border-color: var(--border, #26304A); color: var(--text-primary, #F4F7FF);"
          />
          <span class="icon is-small is-left" style="color: var(--text-secondary, #A8B3CF);">
            <i class="fas fa-search"></i>
          </span>
          ${this.value ? html`
            <span class="icon is-small is-right" style="pointer-events: all; cursor: pointer; color: var(--text-secondary, #A8B3CF);"
              data-cy="search-filter-clear"
              @click="${this._clear}">
              <i class="fas fa-times"></i>
            </span>
          ` : ''}
        </div>
      </div>
    `
  }
}

customElements.define('search-filter', SearchFilter)
